import Linkify from 'linkify-react';

import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';

const Container = styled('span')(({ theme }) => ({
  '& .styled-link': {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    wordBreak: 'break-all',
  },
}));

const WithLink = ({ children }) => {
  const options = {
    defaultProtocol: 'https',
    rel: (href, type) => type === 'url' && 'noopener',
    target: (href, type) => type === 'url' && '_blank',
    className: 'styled-link',
  };

  return (
    <Container>
      <Linkify options={options}>{children}</Linkify>
    </Container>
  );
};

WithLink.propTypes = {
  children: PropTypes.node,
};

export default WithLink;
